import {Component, Inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';

import {DialogButtons, DialogData} from '../../../interfaces/data.interfaces';
import {FormValueTypeEnum} from '../../../enums/data.enums';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    imports: [
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule
]
})
export class ConfirmationDialogComponent implements OnInit {

  protected readonly FormValueTypeEnum = FormValueTypeEnum;

  dialogData = signal<DialogData>({})
  title = 'Confirmation';
  message = 'are-you-sure';
  placeholder = 'are-you-sure';
  confirmationButtonTitle = 'Yes';
  buttons: DialogButtons[] = [ { title: 'Cancel', value: false}, { title: this.confirmationButtonTitle, value: true}];

  formGroup = new UntypedFormGroup({
    content: new UntypedFormControl()
  });

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.dialogData.set(data)
  //   if (this.dialogData?.buttons?.length > 0){
  //     this.buttons = this.dialogData?.buttons;
  //   }

  //   if (this.dialogData?.title){
  //     this.title = this.dialogData?.title;
  //   }

  //   if (this.dialogData?.message){
  //     this.message = this.dialogData?.message;
  //   }

  //   if (this.dialogData?.placeholder){
  //     this.placeholder = this.dialogData?.placeholder;
  //   }

  //   if (this.dialogData?.isForm){
  //     this.buttons = [ { title: 'Cancel', value: false}, { title: 'Submit', value: true}];
  //   }
   }

  ngOnInit(): void {
  }
}
